import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/commerce/portals")({
	beforeLoad: () => {
		throw redirect({ to: "/portals" });
	},
});
